import environments from './microfrontend-env.json'
import { MICROFRONTEND_REGISTRY } from './registry'

export interface Microfrontend {
  name: string
  url: string
  activeWhen: string
  roles?: string[]
}

type EnvironmentName = keyof typeof environments

const environmentName = (process.env.CONFIGURATION_ENV || 'development') as EnvironmentName
const { domain } = environments[environmentName]

/** Every micro frontend the shell registers, with bundle urls for the current environment. */
export const microfrontends: Microfrontend[] = MICROFRONTEND_REGISTRY.map(({ name, host, activeWhen, url, roles }) => ({
  name,
  activeWhen,
  roles,
  url: url ?? `https://${host}.${domain}/main.js`,
}))
